import { register } from '../../../Javascript/Utils'

const AccordionContainer = el => {
  const collapseothers = el.dataset.collapseothers
  const accordion = el.querySelectorAll('.medacMoleculeAccordionitem-toggler')

  accordion.forEach(item => item.addEventListener('click', e => {
    accordion.forEach(item => {
      if (e.currentTarget === item) {
        item.parentElement.classList.toggle('is--active')
      } else {
        if (collapseothers) {
          item.parentElement.classList.remove('is--active')
        }
      }
    })
  }))
}

register('AccordionContainer', AccordionContainer)
